import { TradingOrder } from "../config/trading";
import { EditingPosition } from "./editingPosition";


export class EditingOrder {
    private _trd: TradingOrder;
    private _pos: EditingPosition;

    _changed: boolean;
    price: number;

    r_pnl: number; //pnl - fee
    u_pnl: number; //clean pnl

    size: number;

    rr: number; //calculated rr
    r_rr?: number;//rr - fee
    fix: number; //fix precentage

    fee: number;

    get type() { return this.trd.type; }
    get trd() { return this._trd; }
    get pos() { return this._pos; }

    get changed() { return this._changed; }
    set changed(v: boolean) { this._changed = v; }
    constructor(pos: EditingPosition, trd: TradingOrder) {
        this._trd = trd;
        this._pos = pos;
        this.size = trd.size;
        this.price = trd.price;
    }

    delete() {
        const ind = this.pos.targets.findIndex(x => x == this);
        if (ind == -1 || this.pos.targets.length == 1)
            return false;
        this.pos.targets.splice(ind, 1);
        return true;
    }
}
